<template lang="pug">
v-dialog(v-model="dialog" width="680" persistent)
  v-card(v-if="!submited")
    v-card-title Carga rápida (todo en un archivo)
    v-card-text
      v-form(ref="form" @submit.prevent="onSubmit")
        div.mb-2 Sube un solo libro Excel con tus clientes, productos, capacidades y consumos. Creamos solos las clasificaciones, comunas, líneas de negocio y productos base, y armamos tu caso con el Mix Óptimo.
        div.mb-3
          span.mr-1 Descarga la plantilla:
          a(href="/plantilla-carga-maestra.xlsx" target="_blank" download) con ejemplo
          span.mx-1 ·
          a(href="/plantilla-carga-maestra-blanca.xlsx" target="_blank" download) en blanco
          .text-caption.grey--text Usa la de "ejemplo" para entender el formato; la "en blanco" para llenar con tus datos.
          .mt-2
            v-icon.mr-1(small color="primary") mdi-robot-outline
            span.mr-1 ¿Prefieres que una IA la arme por ti?
            a(href="/prompt-plantilla-plan2sell.md" target="_blank" download) Descarga el prompt
            .text-caption.grey--text Pégalo en Claude o ChatGPT junto con la información de tu empresa y te devuelve los datos listos.
        v-file-input(
          label="Archivo (.xlsx)"
          v-model="form.file"
          persistent-hint
          outlined
          accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="onFileChange"
          :rules="v.file")
        .text-right
          v-btn.mr-2(color="primary" outlined @click="closeDialog" :disabled="loading") Cancelar
          v-btn(color="primary" type="submit" :loading="loading") Cargar todo
  v-card(v-else-if="errors && errors.length > 0")
    v-card-title Falló la Carga
    v-card-text
      .d-flex.justify-center.align-center
        v-icon.mx-auto(color="error" size="80") mdi-alert-circle-outline
      v-card-text.text-center Revisa los errores y vuelve a intentar.
      ul
        li(v-for="error in errors" :key="error") {{ error }}
      .text-right.mt-4
        v-btn.mr-2(color="primary" outlined @click="closeDialog" :disabled="loading") Cerrar
  v-card(v-else)
    v-card-title Carga completada
    v-card-text
      .d-flex.justify-center.align-center
        v-icon.mx-auto(color="success" size="80") mdi-check-circle-outline
      v-simple-table.mt-2(dense)
        template(v-slot:default)
          tbody
            tr(v-for="(val, key) in summary" :key="key")
              td {{ labels[key] || key }}
              td.text-right.font-weight-bold {{ val }}
      div.mt-2(v-if="warnings.length")
        .text-caption.font-weight-bold Advertencias:
        ul
          li.text-caption(v-for="w in warnings" :key="w") {{ w }}
      .text-right.mt-4
        v-btn.mr-2(color="primary" outlined @click="closeDialog") Cerrar
        template(v-if="projectionIds.length > 1")
          v-btn.mr-2(color="primary" outlined :to="`/proyeccion-comercial/${projectionIds[0]}/dashboard`") Ver estimado
          v-btn(color="primary" :to="`/proyeccion-comercial/${projectionIds[1]}/dashboard`") Ver real
        v-btn(v-else-if="projectionId" color="primary" :to="`/proyeccion-comercial/${projectionId}/dashboard`") Ver resultados
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormMixin from '@/components/mixins/FormMixin'
import validations from '@/shared/formValidations'

export default {
  mixins: [FormMixin],
  data() {
    return {
      submited: false,
      form: { file: null },
      dialog: false,
      errors: [],
      warnings: [],
      summary: {},
      projectionId: null,
      projectionIds: [],
    }
  },
  methods: {
    ...mapActions('commercial_projection', ['importMaster']),
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    onError(response) {
      this.loading = false
      const data = (response && (response.data || (response.error && response.error.response && response.error.response.data))) || {}
      this.errors = (data.errors && data.errors.length)
        ? data.errors
        : ['No pudimos procesar el archivo. Usa la plantilla (.xlsx) con las hojas Config, Comunas, Clientes, Líneas de Negocio, Productos, Capacidades, Consumo estimado y Consumo real.']
      this.warnings = data.warnings || []
      this.submited = true
      this.$emit('save')
    },
    onSuccess(response) {
      this.loading = false
      const data = (response && response.data) || {}
      this.errors = []
      this.summary = data.summary || {}
      this.warnings = data.warnings || []
      this.projectionId = data.projection_id || null
      this.projectionIds = data.projection_ids || (data.projection_id ? [data.projection_id] : [])
      this.submited = true
      this.$emit('save')
    },
    onFileChange() {
      this.$refs.form && this.$refs.form.resetValidation()
    },
    getAction() {
      return this.importMaster
    },
    getData() {
      const formData = new FormData()
      const data = { data: formData }
      for (const key in this.form) {
        formData.append(key, this.form[key])
      }
      return data
    },
    resetForm() {
      this.form = { file: null }
      this.$refs.form && this.$refs.form.resetValidation()
    },
    onClose() {
      this.errors = []
      this.warnings = []
      this.summary = {}
      this.projectionId = null
      this.projectionIds = []
      this.submited = false
      this.loading = false
      this.resetForm()
    }
  },
  computed: {
    ...mapGetters('app_config', ['currentBusiness']),
    isSimpleMode() {
      return this.currentBusiness && this.currentBusiness.catalog_mode === 'simplificado'
    },
    labels() {
      return {
        clientes: 'Clientes',
        clasificaciones: 'Clasificaciones creadas',
        comunas: 'Comunas nuevas',
        lineas: 'Líneas de negocio',
        productos_base: this.isSimpleMode ? 'Productos y servicios base' : 'Productos base',
        productos: this.isSimpleMode ? 'Productos y servicios' : 'Productos (SKU)',
        consumos: 'Consumos',
      }
    },
    v() {
      return {
        file: [
          validations.isRequired,
          (f) => !f || /\.xlsx$/i.test(f.name || '') || 'El archivo debe ser .xlsx'
        ]
      }
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.onClose()
      }
    }
  },
}
</script>
